import styled from 'styled-components';
import { ColDiv, common } from './Common';

export const SubVisualBox = styled.div`
  position: relative;
  padding: 0 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 460px;
  min-height: 460px;
  background-image: ${({ $visual }) => $visual && `url(${$visual})`};
  background-repeat: no-repeat;
  background-size: cover;
  background-position-y: bottom;

  h2 {
    font-size: 2.75rem;
    line-height: 1.2;
    color: white;
    margin-bottom: 8px;
  }

  @media ${({ theme }) => theme.device.mobile} {
    height: 400px;
    h2 {
      font-size: 2.375rem;
    }
  }
`;

export const SubSection = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  ${common}

  @media ${({ theme }) => theme.device.tablet} {
    padding: ${({ $type }) => ($type === 'tech' && `72px 24px 0`) || `0 24px`};
  }
  @media ${({ theme }) => theme.device.mobile} {
    ${({ $type }) => $type === 'tech' && `padding: 48px 0 0 0`};
  }
`;

export const SubWrap = styled(ColDiv)`
  gap: 48px;

  padding: ${({ $type }) => ($type === 'first' && `0 0 104px`) || `104px 0`};

  @media ${({ theme }) => theme.device.tablet} {
    padding: 72px 0;
  }

  @media ${({ theme }) => theme.device.mobile} {
    gap: 24px;
    padding: 48px 0;
  }
`;
